import { SvgIcon , SvgIconProps} from '@mui/material';

import './ccf-outbound-assignment-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfOutboundAssignmentIconProps extends SvgIconProps {}

/**
 * Function is used to display svg icon of outbound assignment
 * @param props -CcfOutboundAssignmentProps
 * @returns svg icons of outbound assignment
 * @example <CcfOutboundAssignment/>
 */
export function CcfOutboundAssignmentIcon(
  props: CcfOutboundAssignmentIconProps
) {
  return (
    <SvgIcon {...props}>
      <g id="Group_120847" data-name="Group 120847" transform="translate(-101 -384)">
        <g id="Group_120846" data-name="Group 120846" transform="translate(-133 315)">
          <g id="Group_120840" data-name="Group 120840" transform="translate(234.52 70.548)">
            <g id="Group_120782" data-name="Group 120782" transform="translate(0)">
              <g id="btn_inbound" transform="translate(0.48 1.4)">
                <path id="Path_25429" data-name="Path 25429" d="M3847.5-3110.5v4.182h12.96v-4.182" transform="translate(-3847.501 3115.823)" fill="none" stroke="#526b7a" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                <path id="Path_25435" data-name="Path 25435" d="M6.48-5.323V.435" transform="translate(0 5.323)" fill="none" stroke="#526b7a" strokeLinecap="round" strokeWidth="2" />
              </g>
            </g>
          </g>
        </g>
        <path id="Polygon_92" data-name="Polygon 92" d="M3.7,1.067a1,1,0,0,1,1.6,0L7.8,4.4A1,1,0,0,1,7,6H2a1,1,0,0,1-.8-1.6Z" transform="translate(104 384)" fill="#526b7a" />
      </g>
    </SvgIcon>
  );
}

export default CcfOutboundAssignmentIcon;
